<template>
  <BaseModal>
    <div class="qr__content" @click.stop>
      <img src="/qr_light.png" alt="QR Code" class="dialog__qr_img" loading="lazy" />
      <h4>{{ $t('qr.title') }}</h4>
      <p>{{ $t('qr.description') }}</p>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from "@/UI/Modals/BaseModal.vue";
</script>

<style>
.qr__content {
  padding: 30px 20px;
  text-align: center;
  background: var(--bg-color);
  border-radius: 33px;
  min-height: 100px;
  min-width: 200px;
  max-width: 220px;
  margin: auto 0;
}

.qr__content p {
  color: rgba(142, 142, 147, 1);
}

.qr__content h4 {
  margin: 6px 0;
}

.dialog__qr_img {
  background: var(--qr-bg-modal-color);
  border-radius: 25px;
  width: 120px;
  height: 120px;
  padding: 16px;
}
</style>
